import { SignInComponent } from './signin.component';
import { SignUpComponent } from './signup.component';
import { VerificationComponent } from './verification.component';
import { ForgotPasswordComponent } from './forgot-password.component';

export const COMPONENTS = [SignInComponent, SignUpComponent, VerificationComponent, ForgotPasswordComponent];

export {
  SignInComponent,
  SignUpComponent,
  VerificationComponent,
  ForgotPasswordComponent
};



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/components/index.ts